import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor"


export const getMaquinasTintoreria = async () => {
   const respuesta = await PrivateInterceptor('Produccion/Dyeing/MaquinasActivas', 'GET')
   return respuesta;
}
export const getPartidasCargadasMaquina = async () => {
   const respuesta = await PrivateInterceptor('Produccion/Dyeing/PartidasCargadasMaquina', 'GET')
   return respuesta;
}

export const dyeingConsumosPorPartida = async () => {
   const respuesta = await PrivateInterceptor('Produccion/Dyeing/ConsumosPorPartida', 'GET')
   return respuesta;
}

// UltimosParosMaquina
export const getUltimosParosMaquinas = async () => {
   const respuesta = await PrivateInterceptor(`Produccion/Dyeing/UltimosParosMaquinas`, 'GET')
   return respuesta;
}